import React from 'react';
import useManageWords from '~/hooks/managewords/useManageWords';
import ManageWordsList from './components/ManageWordsList';
import ManageWordsLoader from './components/ManageWordsLoader';

export default function ManageWords() {
  const manageWords = useManageWords();

  if (manageWords.loadingConfig.flag)
    return <ManageWordsLoader comment={manageWords.loadingConfig.comment} />;

  return <ManageWordsList manageWords={manageWords} />;
};
